import React from 'react'

import { useAllJobOfferApplications, useJobOffer } from './hooks'
import Loading from '../../components/layout/Loading'
import JobCard from './Card'
import { JobOffer } from '../../../api/job-offers/types'
import NoResults from '../../components/layout/NoResults'

type Props = { queryFn: () => { data: JobOffer[] | null | undefined, isLoading: boolean, error: Error | null }  }
const SimpleList:React.FC<Props> = ({ queryFn }) => {
  const { data: jobOffers, isLoading } = queryFn()
  const [idOpened, setIdOpened] = React.useState<number | null>(null)
  const { data: jobOfferOpened, isLoading: loadingJobOpened } = useJobOffer(idOpened)
  const { data: jobOfferApplications, isLoading: loadingJobOfferApplications } = useAllJobOfferApplications()

  if(!jobOffers || isLoading || loadingJobOfferApplications) { return <Loading /> }
  if(jobOffers.length === 0) { return <NoResults /> }
  return (
    <div className='flex flex-col gap-y-3'>
      {jobOffers
        .map((jobOffer) => {
          return (
            <JobCard
              key={jobOffer.id}
              onClick={() => setIdOpened(idOpened === jobOffer.id ? null : jobOffer.id)}
              jobOffer={jobOffer}
              isOpened={jobOffer.id === idOpened}
              isLoading={loadingJobOpened}
              jobOfferOpened={jobOfferOpened}
              applied={
                !!jobOfferApplications?.find((jobOfferApplication) => jobOfferApplication.jobOfferId === jobOffer.id)
              }
            />
          )
        })
      }
    </div>
  )
}

export default SimpleList
